import React from "react";
import styles from "./PricesBlock.module.scss";
import {
  PricesFromWithChip,
  PricesFromWithChipProps
} from "../../PricesFromWithChip/PricesFromWithChip";

export type PricesBlockProps = Pick<
  PricesFromWithChipProps,
  "prices" | "pricesDisclaimer"
>;

export const PricesBlock: React.FC<PricesBlockProps> = (props) => {
  return (
    <PricesFromWithChip
      variant="normal"
      layout="row-compact"
      wrapperClassName={styles.wrapper}
      itemClassName={styles.item}
      fareClassName={styles.fare}
      pricesDisclaimerClassName={styles.priceDisclaimer}
      {...props}
    />
  );
};
